/* Jaylis — product card secondary VIDEO playback.

   Desktop (hover-capable): play the clip on hover, reset on leave. The clip
   is pre-warmed when the card scrolls into view, so first hover starts the
   video near-instantly instead of showing the back image for the whole
   network+decode latency.
   Mobile / touch (no hover): autoplay the clip while the card is in view
   (muted + looping) AFTER the agreed product-first dwell — via
   IntersectionObserver; pause (without rewinding) when it scrolls out.

   Works on all three card surfaces:
     - .jcl-card     (sections/jaylis-collection.liquid → .jcl-card__video)
     - .card-gallery (snippets/card-gallery.liquid       → .card-hover-video)
     - .mtg-card     (sections/metagon-bestsellers.liquid → .mtg-img-video)

   Audit 12.06. (mobile videos never played — three confirmed causes):
   1. The 5s timer demanded 5 UNINTERRUPTED seconds at >=60% visibility and
      every dip below 0.6 cancelled it AND rewound the video — normal thumb
      scrolling reset the clock forever. Now: timer arms at >=45% and is only
      cancelled when the card actually LEAVES the viewport; pause keeps the
      position; once a card has played once (__hvUnlocked) it resumes
      immediately on re-entry.
   2. The bestsellers mobile carousel shows the neighbor card at max ~55%
      visibility — 0.6 was unreachable for it. Threshold is 0.45 now.
   3. play() can be rejected on phones (iOS Low Power Mode etc.) — we retry
      once on the next touch instead of failing silently.

   The <video data-hover-video> is rendered muted/playsinline/loop with
   preload="none" + data-src; we set the source when the card approaches the
   viewport (warm start) and toggle .is-playing (the CSS fades it in).
   Survives Horizon section morph. */
(function () {
  if (window.__jaylisHoverVideoInit) return;
  window.__jaylisHoverVideoInit = true;

  // (hover: none) => phones / touch tablets with no mouse.
  var noHover = window.matchMedia && window.matchMedia('(hover: none)').matches;

  // Meeting 11.06.: the product photo must be visible ~5 seconds before the
  // video appears (first time per card; afterwards it resumes instantly).
  var MOBILE_VIDEO_DELAY_MS = 5000;
  var ARM_RATIO = 0.45; // carousel neighbor card maxes out at ~0.55

  function warm(v) {
    // Attach the source + fetch metadata as the card approaches the
    // viewport, so play() doesn't stall on first use.
    if (!v.getAttribute('src')) {
      var s = v.getAttribute('data-src');
      if (s) {
        v.setAttribute('src', s);
        try { v.preload = 'auto'; } catch (e) {}
      }
    }
  }
  function play(v) {
    warm(v);
    var p = v.play();
    if (p && p.then) {
      p.then(function () {
        v.__hvUnlocked = true;
        v.classList.add('is-playing');
      }).catch(function () {
        // Autoplay rejected (Low Power Mode, data saver …): retry once on
        // the next touch anywhere on the card's surface.
        if (v.__hvRetryBound) return;
        v.__hvRetryBound = true;
        var t = v.closest('.jcl-card, .card-gallery, .mtg-card') || v;
        t.addEventListener('touchstart', function retry() {
          t.removeEventListener('touchstart', retry);
          v.__hvRetryBound = false;
          play(v);
        }, { passive: true, once: true });
      });
    } else {
      v.__hvUnlocked = true;
      v.classList.add('is-playing');
    }
  }
  function stop(v, rewind) {
    v.classList.remove('is-playing');
    try {
      v.pause();
      if (rewind) v.currentTime = 0; // desktop hover-out resets; mobile keeps position
    } catch (e) {}
  }

  // ----- Desktop: hover (plus viewport pre-warming) -----
  function bindHover(v) {
    var trigger = v.closest('.jcl-card, .card-gallery, .mtg-card');
    if (!trigger) return;
    trigger.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'touch') return;
      play(v);
    });
    trigger.addEventListener('pointerleave', function () { stop(v, true); });
  }

  var warmIo = null;
  function getWarmObserver() {
    if (warmIo) return warmIo;
    if (!('IntersectionObserver' in window)) return null;
    warmIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          warm(en.target);
          warmIo.unobserve(en.target);
        }
      });
    }, { rootMargin: '25% 0px' });
    return warmIo;
  }

  // ----- Mobile: autoplay while in view, product-photo-first -----
  var io = null;
  function getObserver() {
    if (io) return io;
    if (!('IntersectionObserver' in window)) return null;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          warm(v);
          if (en.intersectionRatio >= ARM_RATIO) {
            if (v.__hvUnlocked) {
              // Already earned its first play — resume immediately.
              if (!v.classList.contains('is-playing')) play(v);
            } else if (!v.__hvTimer) {
              v.__hvTimer = setTimeout(function () {
                v.__hvTimer = null;
                play(v);
              }, MOBILE_VIDEO_DELAY_MS);
            }
          }
          // Dips below ARM_RATIO while still visible do NOT cancel the
          // timer and do NOT pause — that jitter was the reset loop.
        } else {
          if (v.__hvTimer) { clearTimeout(v.__hvTimer); v.__hvTimer = null; }
          stop(v, false); // pause, keep position
        }
      });
    }, { threshold: [0, ARM_RATIO, 1] });
    return io;
  }

  function bind(v) {
    if (v.__hvBound) return;
    v.__hvBound = true;
    if (noHover) {
      var ob = getObserver();
      if (ob) ob.observe(v);
      else play(v); // no IO support: just play it
    } else {
      bindHover(v);
      var wob = getWarmObserver();
      if (wob) wob.observe(v);
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('video[data-hover-video]').forEach(bind);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
